import axios from 'axios'
import Qs from 'qs'
import { Notify } from 'vant'
var baseURL = process.env.VUE_APP_BASEURL
export {
  baseURL
}
axios.defaults.baseURL = process.env.VUE_APP_BASEURL
const addMeta = (name, content) => {
  const meta = document.createElement('meta')
  meta.httpEquiv = name
  meta.content = content
  document.getElementsByTagName('head')[0].appendChild(meta)
}
if (process.env.VUE_APP_MODEL === 'production') {
  addMeta(
    'Content-Security-Policy',
    'upgrade-insecure-requests'
  )
}
// 请求超时时间
axios.defaults.timeout = 60000
// 设置post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// 请求拦截器
const CancelToken = axios.CancelToken
const source = CancelToken.source()
axios.interceptors.request.use(
  config => {
    if (/^\/apis/.test(config.url)) {
      config.baseURL = ''
      return config
    }
    // 自定义请求头参数
    // const token = sessionStorage.getItem('token' + Vue.prototype.$logo()) || ''
    if (!!window.ActiveXObject || 'ActiveXObject' in window) { // 判断是不是ie浏览器
      if (config.method === 'post') {
        // 判断是不是formdata格式
        if (Object.prototype.toString.call(config.data) != '[object FormData]') { // eslint-disable-line
          config.data = Qs.stringify(filter({
            ...config.data
          }))
        }
      } else if (config.method === 'get') {
        config.params = filter({
          ...config.params
        })
      }
    } else {
      config.headers['u-login-areaId'] = 410000
      if (config.method === 'post') {
        if (Object.prototype.toString.call(config.data) != '[object FormData]') { // eslint-disable-line
          if (config.headers['Content-Type'] !== 'application/json;charset=UTF-8') {
            config.data = Qs.stringify(filter(config.data))
          }
        }
      } else if (config.method === 'get') {
        config.params = filter(config.params)
      }
    }
    return config
  }, error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)
// 响应拦截器
axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    var code = response.data.errcode || response.data.code
    var message = response.data.errmsg || response.data.message || response.data.data
    if (code === 200) {
      return Promise.resolve(response)
    } else if (code === 302) {
      Notify({ type: 'danger', message })
      sessionStorage.clear()
      // router.push({
      //   name: 'login'
      // })
      return Promise.reject(response)
    } else if (code === 400) {
      // ElMessage .error('参数异常')
      Notify({ type: 'danger', message })
      return Promise.reject(response)
    } else if (code === undefined) { // undefind 为文件下载接口
      return Promise.resolve(response)
    } else {
      Notify({ type: 'danger', message })
      return Promise.reject(response)
    }
  }, error => {
    return Promise.reject(error)
  }
)

function filter (param = {}) { // 参数过滤
  var data = param
  if (data.empty && data.id) {
    var nullValueFields = []
    for (const key in data) {
      if (data[key] === null || data[key] === '') {
        // data[key] = 'EMPTY'
        nullValueFields.push(key)
      }
    }
    data.nullValueFields = nullValueFields.join(',')
    delete data.empty
  } else {
    for (const key in data) {
      if (data[key] === null) {
        delete data[key]
      }
    }
  }
  // console.log(param)
  // console.log(data)
  return data
}
// 封装get请求
export const get = (url, params, headers) => {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      headers: headers,
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
// 封装post请求加了qs序列化数据
export const post = (url, params, headers) => {
  return new Promise((resolve, reject) => {
    axios.post(url, filter(params), {
      headers: headers,
      cancelToken: source.token
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 封装post请求用于FormData请求
export const postform = (url, params, headers) => {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {
      headers: headers
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/* 接收后台文件流 */
export const filedownload = (url, params, type = 'blob', timeOut = 600000) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: url,
      data: params,
      timeout: timeOut,
      responseType: type
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 接收后台文件流
export const fileRequest = (url, params, text) => {
  return axios({
    method: 'post',
    url: url,
    data: params,
    responseType: 'blob'
  }).then(res => {
    const content = res.data
    const blob = new Blob([content])
    const fileName = text
    if ('download' in document.createElement('a')) { // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else { // IE10+下载
      navigator.msSaveBlob(blob, fileName)
    }
  })
}
// 接收后台文件流下载Word文件
export const downloadWord = (url, params, text, types) => {
  return axios({
    method: 'post',
    url: url,
    data: params,
    responseType: 'blob'
  }).then(res => {
    const content = res.data
    const blob = new Blob([content], { type: types })
    const fileName = text
    if ('download' in document.createElement('a')) { // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else { // IE10+下载
      navigator.msSaveBlob(blob, fileName)
    }
  })
}
// json 参数形式
export const _post = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

function toFormData (params) {
  const data = new FormData()
  for (var i in params) {
    data.append(i, params[i])
  }
  return data
}
const postForm = (url, params, headers) => {
  params = toFormData(params)
  return new Promise((resolve, reject) => {
    axios.post(url, params, {
      headers: headers
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export const postformProgress = (url, params, timeout, callback, id) => {
  return new Promise((resolve, reject) => {
    axios({
      url,
      method: 'post',
      data: params,
      timeout,
      onUploadProgress: e => {
        callback(e, id)
      }
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
export const cancelToken = (msg) => {
  source.cancel(msg)
  console.log(source.cancel)
}
export default {
  get,
  post: _post,
  postForm,
  upload: postform,
  cancelToken
}
